import { render, staticRenderFns } from "./FeedUser.vue?vue&type=template&id=9b57233a&scoped=true"
import script from "./FeedUser.vue?vue&type=script&lang=js"
export * from "./FeedUser.vue?vue&type=script&lang=js"
import style0 from "./FeedUser.vue?vue&type=style&index=0&id=9b57233a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b57233a",
  null
  
)

export default component.exports